<template>
  <div class="login-form login-signin">
    <div class="text-center mb-10 mb-lg-20">
      <h2 class="font-weight-boldest" v-if="formShow">申请成为时云用户</h2>
      <h2 class="font-weight-boldest" v-else>申请资料提交成功</h2>
      <p class="text-muted font-weight-bold" v-if="formShow">
        请填写您的基本信息申请成为时云用户
      </p>
    </div>
    <!--begin::Form-->
    <form class="form" v-if="formShow">
      <div class="form-group py-2 m-0 apply_border_bottom">
        <label class="mb-0"
          >您的企业名称<span class="text-danger ml-2">*</span></label
        >
        <input
          class="form-control h-auto border-0 px-0 placeholder-dark-75 py-1"
          type="text"
          autocomplete="off"
          v-model="applyDate.companyName"
        />
      </div>
      <div class="form-group py-2 m-0 apply_flex">
        <div class="apply_border_bottom apply_flex_half">
          <label class="mb-0"
            >您的姓名<span class="text-danger ml-2">*</span></label
          >
          <input
            class="form-control h-auto border-0 px-0 placeholder-dark-75 py-1"
            type="text"
            autocomplete="off"
            v-model="applyDate.userName"
          />
        </div>
        <div class="apply_border_bottom apply_flex_half">
          <label class="mb-0">职务</label>
          <input
            class="form-control h-auto border-0 px-0 placeholder-dark-75 py-1"
            type="text"
            autocomplete="off"
            v-model="applyDate.position"
          />
        </div>
      </div>
      <div class="form-group py-2 m-0 apply_border_bottom">
        <label class="mb-0"
          >手机号<span class="text-danger ml-2">*</span></label
        >
        <input
          class="form-control h-auto border-0 px-0 placeholder-dark-75 py-1"
          type="text"
          autocomplete="off"
          v-model="applyDate.mobile"
        />
      </div>
      <div class="form-group py-2 m-0 apply_flex">
        <div class="apply_border_bottom apply_flex_half">
          <label class="mb-0">邮箱<span class="text-danger ml-2">*</span></label>
          <input
            class="form-control h-auto border-0 px-0 placeholder-dark-75 py-1"
            type="text"
            autocomplete="off"
            v-model="applyDate.email"
          />
        </div>
        <div class="apply_border_bottom apply_flex_half">
          <label class="mb-0">联系电话</label>
          <input
            class="form-control h-auto border-0 px-0 placeholder-dark-75 py-1"
            type="text"
            autocomplete="off"
            v-model="applyDate.telephone"
          />
        </div>
      </div>
      <div class="form-group py-2 m-0">
        <label class="mb-0"
          >所在地区<span class="text-danger ml-2">*</span></label
        >
        <div
          class="form-control h-auto border-0 px-0 placeholder-dark-75 py-1 text-center"
        >
          <v-region @values="regionChange" class="apply_region"></v-region>
        </div>
      </div>
      <div class="form-group py-2 border-bottom m-0 code_flex">
        <div>
          <label class="mb-0"
            >验证码<span class="text-danger ml-2">*</span></label
          >
          <input
            type="text"
            class="form-control h-auto border-0 px-0 placeholder-dark-75 py-1"
            v-model="applyDate.verifyCode"
          />
        </div>
        <div>
          <button
            type="button"
            class="btn btn-outline-primary"
            v-if="codeShow"
            @click="eRegisterSms"
          >
            发送
          </button>
          <button
            v-if="!codeShow"
            disabled
            class="btn btn-light btn-text-dark btn-hover-text-dark font-weight-bold"
          >
            发送 ({{ count }})
          </button>
        </div>
      </div>
      <div class="form-group py-3 m-0 apply_border_bottom">
        <label class="mb-0">申请说明</label>
        <input
          class="form-control h-auto border-0 px-0 placeholder-dark-75 py-1"
          type="text"
          autocomplete="off"
          v-model="applyDate.applyContent"
        />
      </div>
      <div
        class="mt-6 form-group d-flex flex-wrap justify-content-between align-items-center mt-3"
      >
        <div class="checkbox-inline">
          <label class="checkbox checkbox-outline m-0 text-drak">
            <input type="checkbox" name="remember" v-model="checkboxVal" />
            <span></span>
            我同意
          </label>
          <span class="protocol text-primary"
            ><a>时云用户协议</a>、<a>阿里云用户协议</a></span
          >
        </div>
      </div>
      <div class="form-group d-flex flex-wrap flex-center">
        <button
          type="button"
          class="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
          @click="eSubmit"
        >
          提交
        </button>
        <router-link
          to="/auth/login"
          type="button"
          class="btn btn-outline-primary font-weight-bold px-9 py-4 my-3 mx-4"
        >
          返回官网
        </router-link>
      </div>
    </form>
    <div class="text-success ml-5" v-else>
      <div>系统已收到您的注册申请，请耐心等候1-3个工作日审核。</div>
      <div>
        审核完成后，系统将审核结果发送到您填写的手机号，请注意查收，谢谢。
      </div>
      <div class="apply_button_flex">
        <router-link
          to="/auth/login"
          type="button"
          class="btn btn-outline-primary font-weight-bold px-9 py-4 my-3 mx-4"
        >
          返回官网
        </router-link>
      </div>
    </div>
    <!--end::Form-->
  </div>
</template>

<script>
export default {
  name: "PagesAuthRegister",
  data() {
    return {
      applyDate: {
        companyName: "",
        userName: "",
        position: "",
        mobile: "",
        telephone: "",
        email: "",
        verifyCode: "",
        applyContent: "",
        region: {},
        verifySN: "",
      },
      formShow: true,
      codeShow: true,
      count: "",
      timer: null,
      checkboxVal:false
    };
  },
  watch:{
      
  },
  methods: {
    regionChange(data) {
      this.applyDate.region = data;
      console.log(this.applyDate.region);
    },
    eRegisterSms() {
      let args = {
        mobile: `+86-${this.applyDate.mobile}`,
      };
      if (!args.mobile) {
        return;
      }
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeShow = false;
        this.timer = setInterval(() => {
          if (this.count > 1 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
      this.$$.api
        .post(
          "/kernel/authentication/apis/open/authorization/sms/register",
          args
        )
        .then((res) => {
          this.$$.toastr.success("短信发送成功，请注意查收");
          this.applyDate.verifySN = res.data.sn;
          console.log(this.applyDate.verifySN);
        })
        .catch((e) => {
          this.$$.toastr.error(e.message);
          this.codeShow = true;
          clearInterval(this.timer);
          this.timer = null;
        });
    },
    eSubmit() {
      if (!this.applyDate.userName) {
        this.$$.toastr.error("请填写您的姓名");
        return;
      }
      if (!this.applyDate.companyName) {
        this.$$.toastr.error("请填写您的企业名称");
        return;
      }
      if (!this.applyDate.region) {
        this.$$.toastr.error("请选择您所在地区");
        return;
      }
      if (!this.applyDate.region.province) {
        this.$$.toastr.error("请选择所在省份");
        return;
      }
      if(!this.applyDate.email){
         this.$$.toastr.error("请填写您的邮箱");
        return;
      }
      var patrn = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/;
      if (!patrn.test(this.applyDate.email)) {
        this.$$.toastr.error("请填写正确的邮箱格式");
        return false;
      }
      if (!this.applyDate.region.city) {
        this.$$.toastr.error("请选择所在城市");
        return;
      }
      if (!this.applyDate.region.area) {
        this.$$.toastr.error("请选择所在区县");
        return;
      }
      if (!this.applyDate.mobile) {
        this.$$.toastr.error("请填写您的手机号");
        return;
      }
      if (!this.applyDate.verifyCode) {
        this.$$.toastr.error("请填写验证码");
        return;
      }
      if(this.checkboxVal == false){
          this.$$.toastr.error("请勾选同意协议");
          return;
      }
      let args = {
        companyName: this.applyDate.companyName,
        name: this.applyDate.userName,
        position: this.applyDate.position,
        mobile: `+86-${this.applyDate.mobile}`,
        telephone: this.applyDate.telephone,
        email: this.applyDate.email,
        verifyCode: this.applyDate.verifyCode,
        applyContent: this.applyDate.applyContent,
        addr: {
          Country: { code: "CN", name: "中国" },
          Province: {
            code: this.applyDate.region.province.key,
            name: this.applyDate.region.province.value,
          },
          City: {
            code: this.applyDate.region.city.key,
            name: this.applyDate.region.city.value,
          },
          Area: {
            code: this.applyDate.region.area.key,
            name: this.applyDate.region.area.value,
          },
        },
        verifySN: this.applyDate.verifySN,
      };
      this.$$.api
        .post("/shiyun/marketing/apis/open/customer/apply/add", args)
        .then(() => {
          this.$$.toastr.success("提交成功");
          this.formShow = false;
        })
        .catch((error) => {
          this.$$.toastr.error(error.message);
        });
    },
  },
};
</script>

<style>
.apply_border_bottom {
  border-bottom: 1px solid #efefef;
}
.apply_flex {
  display: flex;
  justify-content: space-between;
}
.apply_flex_half {
  width: 45%;
}
.apply_region {
  display: flex !important;
  flex-wrap: wrap;
}
.apply_region div.v-dropdown-caller {
  margin: 3px !important;
}
.code_flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.apply_button_flex {
  display: flex;
  justify-content: center;
}
</style>
